//@ts-check
import Vue from "vue";
import Vuex from "vuex";
import moment from "moment-timezone";
import Configuration from "../../core/Configuration.js";
import { Settings } from 'luxon';

Vue.use(Vuex);

const strings = {
  fr: require("./i18n/fr.json"),
  en: require("./i18n/en.json")
};

const currencySymbolPosition = {
  fr: 'after',
  en: 'before'
};

/**
 * @param {string} firstLocale
 * @param {string} secondLocale
 * @param {object} first
 * @param {object} second
 * @param {string} [parent]
 */
let check = function(firstLocale, secondLocale, first, second, parent) {
  let skip = [];
  for (let key in first) {
    if (typeof second[key] == "undefined") {
      console.log("[LOCALE ERROR] Key '" + (parent ? parent + "." + key : key) + "' missing in lang '" + secondLocale + "'");
      skip.push(key);
    } else if (typeof first[key] == "object") {
      check(firstLocale, secondLocale, first[key], second[key], parent ? parent + "." + key : key);
    }
  }
}
check("fr", "en", strings.fr, strings.en);
check("en", "fr", strings.en, strings.fr);

let store = new Vuex.Store({
  state: {
    locale: "fr",
    currencySymbolPosition: currencySymbolPosition,
    strings: strings
  },
  mutations: {
    setLocale(state, locale) {
      state.locale = locale;
      Configuration.write("locale", locale);
      Settings.defaultLocale = locale;
      moment.locale(locale);
    }
  },
  getters: {
    get: (state) => (id) => {
      if (!id) {
        return "";
      }
      let split = id.split(".");
      let root = state.strings[state.locale];
      for (let key of split) {
        if (root == null) {
          break;
        }
        root = root[key];
      }
      if (root == null) {
        console.log("[LOCALE ERROR] Could not find locale string with key '" + id + "'");
      }
      return root || id;
    },
    getLocales: (state) => {
      return Object.keys(state.strings);
    },
    getFromObject: (state) => (obj = {}) => {
      return obj[state.locale] || obj["fr"] || obj["en"];
    },

    getCurrencySymbolPosition: (state) => {
      return state.currencySymbolPosition[state.locale];
    },

    getCurrencySymbol: (state) => (amount) => {
      switch (state.currencySymbolPosition[state.locale]) {
        case 'before':
          return '$' + amount;
        case 'after':
          return amount + '$';
        default:
          return '$' + amount;
      }
    }
  }
})

let plugin = {
  install(Vue, options = {}) {
    Vue.prototype.$t = store.getters.get;
    Vue.prototype.$to = store.getters.getFromObject;
    Vue.prototype.$ts = store;
    Vue.prototype.$tc = store.getters.getCurrencySymbol;
    window["translate"] = store.getters.get;
  }
}

export { plugin as Localize, store as LocalizeStore };